
class CartQuantityBlock extends HTMLElement {
  constructor() {
    super();
    this.inputField = this.querySelector(".cart_qty_field");
    this.increaseButton = this.querySelector(".increase_item_qty");
    this.decreaseButton = this.querySelector(".decrease_item_qty");
    this.itemId = this.inputField.dataset.id;

    this.attachEventListeners();
  }

  attachEventListeners() {
    if (this.increaseButton) {
      this.increaseButton.addEventListener("click", () => this.updateQuantity(1));
    }
    if (this.decreaseButton) {
      this.decreaseButton.addEventListener("click", () => this.updateQuantity(-1));
    }
    if (this.inputField) {
      this.inputField.addEventListener("change", () => this.handleInputChange());
    }
  }

  updateQuantity(changeBy) {
    const currentQuantity = parseInt(this.inputField.value, 10) || 0;
    const newQuantity = Math.max(0, currentQuantity + changeBy);
    this.inputField.value = newQuantity;
    document.querySelector('[cart-drawer-wraper]')?.classList.add('is-loading-drawer')
    this.updateCart(newQuantity);
  }

  handleInputChange() {
    const newQuantity = Math.max(0, parseInt(this.inputField.value, 10) || 0);
    this.updateCart(newQuantity);
  }

async updateCart(quantity) {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: this.itemId, quantity }),
    });

    if (response.ok) {
      const cartData = await response.json();
      refreshCart();
    } else {
      const errorData = await response.json();
      console.error("Failed to update cart:", errorData);
    }
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

}

customElements.define("quantity-block", CartQuantityBlock);
let itemfreechecked = false
 var itemCountLoaded =  parseInt(document.querySelector('[cart-drawer-wraper]').getAttribute('data-count'))
  if(itemCountLoaded > 0){
        itemfreechecked = true
  }
class CartUpdater {
  constructor(cartContainerSelector) {
    this.cartContainerSelector = cartContainerSelector;
  }

  async fetchCartData() {
    try {
      const response = await fetch(window.location.pathname, {
        headers: { "Content-Type": "text/html" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch cart data");
      }

      return await response.text();
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  }

  async updateCartHTML() {
    const cartContainer = document.querySelector(this.cartContainerSelector);
    if (!cartContainer) {
      console.error(`Cart container not found for selector: ${this.cartContainerSelector}`);
      return;
    }

    const cartHTML = await this.fetchCartData();
    if (cartHTML) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHTML, "text/html");
      const cartCount = doc.querySelector('.header__cart__status');
      const newCartContent = doc.querySelector(this.cartContainerSelector);
      const itemCount =  parseInt(doc.querySelector(this.cartContainerSelector).getAttribute('data-count'))
       document.querySelectorAll('.header__cart__status')?.forEach(count => {
         count.innerHTML = cartCount.innerHTML
       })
      document.querySelector('[cart-drawer-wraper]')?.classList.remove('is-loading-drawer')
      if (newCartContent) {
        cartContainer.innerHTML = newCartContent.innerHTML;
        cartContainer.setAttribute('data-count' , itemCount)
           if(itemfreechecked === false){
          localStorage.setItem("freeitemchecked", itemCount > 0);
        itemfreechecked = true
      }
      } else {
        console.error("Failed to find the new cart content in the fetched HTML.");
      }
    }
  }
}

window.CartUpdater = CartUpdater;

function refreshCart() {
  const cartUpdater = new CartUpdater("[cart-drawer-wraper]");
  cartUpdater.updateCartHTML();
}
function startTimer() {
  setInterval(() => {
  let time = parseInt(localStorage.getItem('timerTime')) || 600;
  let reverse = JSON.parse(localStorage.getItem('timerReverse')) || false;
  let itemCount =  parseInt(document.querySelector('[cart-drawer-wraper]').getAttribute('data-count'))
  let hasFreeItem = localStorage.getItem("freeitemadded");
  let checkedFreeItem = localStorage.getItem("freeitemchecked");
  let freeitemId = document.querySelector('[cart-drawer-wraper] #shppping_cart_checkbox').getAttribute('value')
  let freeitemLineId = document.querySelector('[cart-drawer-wraper] #shppping_cart_checkbox') ? document.querySelector('[cart-drawer-wraper] #shppping_cart_checkbox').getAttribute('line-id') : document.querySelector('[cart-drawer-wraper]').getAttribute('data-free-item-line-id')
  const countdownElement = document.querySelector('.new_timer_cart_drawer .countdown');
  if (countdownElement && itemCount > 0){
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    countdownElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    if (!reverse) {
      time--;
      if (time < 0) {
        reverse = true;
        time = 0;
      }
    } else {
      time++;
      if (time > 600) {
        reverse = false;
        time = 600;
      }
    }

    localStorage.setItem('timerTime', time);
    localStorage.setItem('timerReverse', reverse);
  } else{
   localStorage.removeItem('timerTime');
  localStorage.removeItem('timerReverse');
  // countdownElement.textContent = '10:00';
  }
    if(itemCount === 0  && hasFreeItem == "true" && freeitemId && freeitemLineId && checkedFreeItem == "true"){
          console.log('hasFreeItem' , hasFreeItem)
      document.querySelector('[cart-drawer-wraper] #shppping_cart_checkbox').checked == false
      localStorage.setItem("freeitemadded", false);
     fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id:freeitemLineId , quantity: 0 }),
      })
        .then((response) => response.json())
        .then(() =>  refreshCart())
        .catch((error) =>
          console.error("Error removing item from cart:", error)
        );
    }
          console.log('hasFreeItem' , itemCount > 0 , hasFreeItem , freeitemId ,  freeitemLineId)
    if(itemCount > 0  && hasFreeItem == "false" && freeitemId && checkedFreeItem == "true"){
      document.querySelector('[cart-drawer-wraper] #shppping_cart_checkbox').checked == true
      localStorage.setItem("freeitemadded", true);
      
      const data = {
        id: parseInt(freeitemId),
        quantity: 1
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json', // Equivalent to contentType
    },
    body: JSON.stringify(data) // Equivalent to data: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Item added to cart:', data);
      refreshCart();
      if (callback) callback();
    })
    .catch(error => console.error('Error adding item to cart:', error));
    }
  }, 1000);
}

   let itemCount =  parseInt(document.querySelector('[cart-drawer-wraper]').getAttribute('data-count'));
    localStorage.setItem("freeitemadded", false);
   let hasFreeItem = localStorage.getItem("freeitemadded");
  if(itemCount > 0 && hasFreeItem == "false"){
  localStorage.setItem("freeitemadded", true);
  } else{
  localStorage.setItem("freeitemadded", false);
  }
document.addEventListener('DOMContentLoaded', () => {
  startTimer();
       localStorage.setItem("freeitemchecked", itemCount > 0);

});
document.addEventListener('click', function(event){
  if(event.target.matches('[cart-drawer-close-btn]') || event.target.closest('[cart-drawer-close-btn]')){
      event.preventDefault();
    document.querySelector('[cart-drawer-wraper]')?.classList.remove('is-open')
  }else  if(event.target.matches('[cart-toggle-btn]') || event.target.closest('[cart-toggle-btn]')){
    event.preventDefault();
    document.querySelector('[cart-drawer-wraper]')?.classList.toggle('is-open')
  }else  if(event.target.matches('.remove_cart_item_btn') || event.target.closest('.remove_cart_item_btn')){
    event.preventDefault();
    document.querySelector('[cart-drawer-wraper]')?.classList.add('is-loading-drawer')
    const targetRemove = event.target.matches('.remove_cart_item_btn') ? event.target : event.target.closest('.remove_cart_item_btn');
    const removeId = targetRemove.dataset.id;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: removeId, quantity: 0 }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return response.json().then(function (errorData) {
          throw new Error("Failed to remove item: " + JSON.stringify(errorData));
        });
      })
      .then(function (cartData) {
        console.log("Item removed successfully:", cartData);
         refreshCart();
      })
      .catch(function (error) {
        console.error("Error removing item from cart:", error);
      });
  }
})








